import React, { useCallback, useState } from "react";

import {
    Content,
    ContentBody,
    DialogContainer,
    DialogTop,
    DialogTopLeft,
    DialogTopCenter,
    DialogTopRight,
    DialogFooter,
    DialogFooterCenter,
    BtnInsertNewAnswer,
    ContainerForm,
    BoxItemsContainer,
    BoxItem,
    BoxMultiple,
    BoxSpan,
    BoxSpanSoon,
    FormDescription,
    BoxItemDivider
} from "./style";

import { AiOutlineClose } from "react-icons/ai";
import { FieldProps } from "../../components/Forms/Fields/FieldBuilder";
import api from "../../services/api";
import { Flow } from "../../interfaces/Flow";
import { useToast } from "../../hooks/toast";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";
import { Card } from "../../interfaces/Card";
import { FilterFlowProps } from "../../components/FilterBar/FilterDialog";
import getCardFiltered from "../../middlewares/getCardFiltered";
import getCardSorted from "../../middlewares/getCardSorted";
import getFields from "../../utils/getFields";
import updateFormulaFromCard from "../../utils/Formula/updateFormulaFromCard";
import { useAuth } from "../../hooks/auth";
import { FormAnswerField } from "../../interfaces/FormAnswerField";
import { FormAnswer } from "../../interfaces/FormAnswer";
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

interface DownloadFlowProps {
    open: boolean;
    flow: Flow;
    testModelFlow?: boolean;
    filterFlow?: FilterFlowProps;
    onClose: () => void;
}

const DownloadFlow: React.FC<DownloadFlowProps> = ({ onClose, open, flow, testModelFlow, filterFlow }) => {

    const { addToast } = useToast();
    const { user } = useAuth();

    const [downloadCardMoviment, setDownloadCardMoviment] = useState<boolean>(false);
    const [exportFormat, setExportFormat] = useState<'csv' | 'excel'>('csv');
    const [loadingInsert, setLoadingInsert] = useState<boolean>(false);

    const handleClose = useCallback(async () => {
        onClose();
    }, [onClose]);

    const downloadData = useCallback(async (isWithCardMoviment: boolean) => {

        try {

            setLoadingInsert(true);

            if (flow !== undefined && flow.id_flow > 0
                && flow.flow_steps !== undefined && flow.flow_steps.length > 0) {

                const response = await api.get(`/card/by-flow`, {
                    params: {
                        flow_id: flow.id_flow,
                        isTestModel: testModelFlow !== undefined ? testModelFlow : undefined,
                        isWithTimeTracking: 'true',
                        isWithPreAnswer: 'true',
                        isWithCardMoviment: isWithCardMoviment,
                    }
                });

                await api.post('/log-history', {
                    log_type_id: 56, //Log Type: Download Flow
                    flow_id: flow.id_flow,
                    change_type: 'E',
                    description: ` fez a exportação de dados do fluxo`,
                    parent_id: flow.id_flow,
                })

                if (response.data !== null) {
                    let cardsApi: Card[] = response.data;

                    if (filterFlow !== undefined) {
                        cardsApi = getCardFiltered(cardsApi, user.id_user, filterFlow.conditions, filterFlow.searchText);
                        cardsApi = getCardSorted(cardsApi, filterFlow.orderBy);
                    }

                    let fields: FieldProps[] = [];
                    if (flow.form_init !== undefined && flow.flow_steps !== undefined) {
                        fields = getFields(flow.form_init, flow.flow_steps);
                    }

                    cardsApi = cardsApi.map((card) => {
                        return updateFormulaFromCard(card, fields);
                    });

                    //Create the object to export
                    let obj: object[] = [];
                    for (let index = 0; index < cardsApi.length; index++) {
                        const c = cardsApi[index];

                        let objCard: any = {
                            id_card: c.id_card,
                            title: c.title,
                            dt_created: c.dt_created,
                            dt_due: c.dt_due,
                            complete: c.complete,
                            flow_step: c.flow_step?.name,
                            flow: flow.name,
                            dt_due_string: c.dt_due_string,
                            user: c.user?.name,
                            status_dt_due: c.status_dt_due
                        }

                        if (filterFlow !== undefined && filterFlow.fieldView !== undefined && filterFlow.fieldView.length > 0) {

                            const fieldViewActive = filterFlow.fieldView.filter((fv) => fv.active);

                            if (fieldViewActive !== undefined && fieldViewActive.length > 0) {
                                for (let idxA = 0; idxA < fieldViewActive.length; idxA++) {
                                    const fv = fieldViewActive[idxA];

                                    let value: FormAnswerField[] | undefined = undefined;

                                    if (fv.id_field > 0) {

                                        if (c.form_answers !== undefined && c.form_answers.length > 0) {
                                            //Filter the form answer with the same form_id
                                            const formAnswer = c.form_answers.filter((answer: FormAnswer) => answer.form_id === fv.form_id);

                                            //Get the form answer with the biggest id
                                            let newerFormAnswer: FormAnswer | undefined = undefined;
                                            if (formAnswer !== undefined && formAnswer.length > 1) {
                                                newerFormAnswer = formAnswer.reduce((prev: FormAnswer, current: FormAnswer) => (prev.id_form_answer > current.id_form_answer) ? prev : current);
                                            } else {
                                                newerFormAnswer = formAnswer[0];
                                            }

                                            //Get the form answer field with the same field_id
                                            if (newerFormAnswer !== undefined && newerFormAnswer.form_answer_fields !== undefined && newerFormAnswer.form_answer_fields.length > 0) {
                                                value = newerFormAnswer.form_answer_fields.filter((answer: FormAnswerField) => answer.field_id === fv.id_field);
                                            }
                                        } else {
                                            value = undefined;
                                        }

                                        if (value !== undefined && value.length > 0) {

                                            let valueString = "";

                                            value.map((val, index) => {

                                                if (index >= 1) {
                                                    valueString += "; ";
                                                }

                                                if (val.valueString !== undefined) {
                                                    valueString += val.valueString;
                                                }

                                                return val;
                                            })

                                            objCard[fv.title] = valueString;
                                        } else {
                                            objCard[fv.title] = "";
                                        }

                                    }

                                }
                            }

                        }

                        //Check if movementMetrics has any data
                        if (c.movementMetrics && typeof c.movementMetrics === 'object') {
                            // Iterate through all properties in movementMetrics
                            Object.keys(c.movementMetrics).forEach(key => {
                                // Add each property as a column in the CSV
                                objCard[key] = c.movementMetrics[key];
                            });
                        }

                        obj.push(objCard);
                    }

                    // Export based on the selected format
                    if (exportFormat === 'csv') {
                        const csv = Papa.unparse(obj);
                        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
                        saveAs(blob, `${flow.name}.csv`);
                    } else {
                        // Excel export
                        const worksheet = XLSX.utils.json_to_sheet(obj);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
                        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob, `${flow.name}.xlsx`);
                    }

                    setLoadingInsert(false);
                    onClose();

                    addToast({
                        type: 'success',
                        title: 'Download iniciado',
                        description: `O download do arquivo ${exportFormat === 'csv' ? 'CSV' : 'Excel'} foi iniciado com sucesso!`,
                    });
                }

            }
        } catch (error) {
            addToast({
                type: 'error',
                title: 'Erro ao carregar os dados do Fluxo',
                description: 'Ocorreu ao tentar carregar os dados do Fluxo!',
            });
        }
    }, [addToast, flow, testModelFlow, filterFlow, user, onClose, exportFormat]);

    const handleSubmitPage = useCallback(async () => {
        if (flow !== undefined && flow.id_flow > 0) {
            downloadData(downloadCardMoviment);
        }
    }, [downloadData, flow, downloadCardMoviment]);

    return (
        <DialogContainer
            fullWidth={true}
            maxWidth="sm"
            open={open}
            onClose={handleClose}
        >
            <DialogTop>
                <DialogTopLeft>
                    <h1>
                        {"Exportar os dados"}
                    </h1>
                </DialogTopLeft>

                <DialogTopCenter />

                <DialogTopRight>
                    <button onClick={handleClose}><AiOutlineClose /></button>
                </DialogTopRight>
            </DialogTop>
            <Content>
                <ContentBody container>

                    <ContainerForm>

                        <FormDescription>O download será feito com base na visualização atual, considerando os campos selecionados, os filtros aplicados e a ordenação definida. Para personalizar o arquivo exportado, ajuste sua visualização conforme desejado.</FormDescription>

                        <BoxItemsContainer>

                            <BoxItem key={2} onClick={() => setExportFormat('csv')}>
                                <BoxMultiple>
                                    {exportFormat === 'csv' ?
                                        <BsToggleOn color="green" /> :
                                        <BsToggleOff />
                                    }
                                </BoxMultiple>
                                <BoxSpan style={{ backgroundColor: 'transparent', paddingLeft: '0px' }}>Exportar como CSV</BoxSpan>
                            </BoxItem>

                            <BoxItem key={3} onClick={() => setExportFormat('excel')}>
                                <BoxMultiple>
                                    {exportFormat === 'excel' ?
                                        <BsToggleOn color="green" /> :
                                        <BsToggleOff />
                                    }
                                </BoxMultiple>
                                <BoxSpan style={{ backgroundColor: 'transparent', paddingLeft: '0px' }}>Exportar como Excel</BoxSpan>
                            </BoxItem>

                            <BoxItemDivider />

                            <BoxItem key={1} onClick={() => setDownloadCardMoviment(!downloadCardMoviment)}>
                                <BoxMultiple>
                                    {downloadCardMoviment ?
                                        <BsToggleOn color="green" /> :
                                        <BsToggleOff />
                                    }
                                </BoxMultiple>
                                <BoxSpan style={{ backgroundColor: 'transparent', paddingLeft: '0px' }}>Adicionar datas de movimentação por etapa </BoxSpan>
                            </BoxItem>

                            <BoxItem key={4}>
                                <BoxMultiple>
                                    <BsToggleOff />
                                </BoxMultiple>
                                <BoxSpan style={{ backgroundColor: 'transparent', paddingLeft: '0px' }}>Adicionar indicadores do cartão</BoxSpan>
                                <BoxSpanSoon>Em breve</BoxSpanSoon>
                            </BoxItem>

                            <BoxItem key={5}>
                                <BoxMultiple>
                                    <BsToggleOff />
                                </BoxMultiple>
                                <BoxSpan style={{ backgroundColor: 'transparent', paddingLeft: '0px' }}>Adicionar comentários do cartão</BoxSpan>
                                <BoxSpanSoon>Em breve</BoxSpanSoon>
                            </BoxItem>
                        </BoxItemsContainer>
                    </ContainerForm>

                </ContentBody>
            </Content>
            <DialogFooter>
                <DialogFooterCenter>
                    <BtnInsertNewAnswer color={"#9337ed"} style={{ width: '150px', height: '36px' }} onClick={() => handleSubmitPage()} isLoading={loadingInsert}>
                        Fazer download
                    </BtnInsertNewAnswer>
                </DialogFooterCenter>
            </DialogFooter>
        </DialogContainer >
    );

}

export default DownloadFlow;